import React from "react";
import "./MtiButton.css";

export type MTIButtonProps = {
  size?: "small" | "medium" | "large";
  variant?: "primary" | "secondary" | "tertiary";
  colorVariant?: "default" | "alternate" | "success" | "error" | "black";
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
  tooltip?: string;
};

export default function MtiButton({
  size = "medium",
  variant = "primary",
  colorVariant = "default",
  disabled = false,
  onClick = () => {},
  onKeyPress = () => {},
  style = {},
  className = "",
  children = null,
  tooltip,
}: MTIButtonProps) {
  let btnClass =
    "btn btn-" +
    size +
    " btn-" +
    colorVariant +
    " btn-" +
    variant +
    " " +
    className;

  return (
    <button
      data-for="common-tooltip"
      data-tip={tooltip}
      data-tip-disable={tooltip == null}
      data-effect="solid"
      data-place="bottom"
      style={{ ...style }}
      disabled={disabled}
      className={btnClass}
      onClick={onClick}
      onKeyDown={onKeyPress}
    >
      {children}
    </button>
  );
}
